import Button from '@anm/components/buttons/Button';
import IconButton from '@anm/components/buttons/IconButton';
import { FC } from 'react';

import Loader from '../../../../my-projects/MyStreamsSection/Loader';
import { useProjectStreams } from '../../../../my-projects/MyStreamsSection/hooks/useStreamsList';
import StreamItemWrapper from '../../../../stream/SteamItemWrapper';
import { createProjectFromRecordings, openRecordingFolder } from '../../../../stream/SteamItemWrapper/helpers';

import { ButtonsWrapper, Error, Title, TitleContainer, Wrapper } from './Wrapper';

type BroadcastTabProps = {
  title: string;
};

const BroadcastTab: FC<BroadcastTabProps> = ({ title }) => {
  const [isError, isPending, data] = useProjectStreams();

  if (isPending) return <Loader />;

  if (isError) {
    return <Error icon="images/icons/refresh.png" title="Something went wrong.<br> Try to refresh" />;
  }

  const firstStream = data?.[0];
  const hasLocalRecording = !!firstStream?.meta.recordingFolderId;

  return (
    <Wrapper>
      <TitleContainer>
        <Title {...{ title }} />
      </TitleContainer>
      {hasLocalRecording && firstStream && (
        <ButtonsWrapper>
          <IconButton
            size="big"
            variant="blue-heavy-border"
            icon="images/icons/blue-folder-ic.svg"
            onClick={() =>
              firstStream?.meta.recordingFolderId && openRecordingFolder(firstStream?.meta.recordingFolderId)
            }
          >
            Open Recordings Folder
          </IconButton>
          <Button
            variant="blue-heavy-border"
            size="big"
            onClick={() => createProjectFromRecordings(firstStream?.streamId)}
          >
            Project from Recordings
          </Button>
        </ButtonsWrapper>
      )}
      {data?.map(item => (
        <StreamItemWrapper key={item.streamId} {...item} />
      ))}
    </Wrapper>
  );
};

export default BroadcastTab;
